export default "__VITE_ASSET__DaXWEzXz__"